module.exports = __webpack_public_path__ + "img/23.4bc8adde.png";